import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { SignUpCompletedComponent } from '../driver-job/sign-up-completed/sign-up-completed.component';
import { PhoneMaskDirective } from '../phone-mask/phone-mask.directive';
import { InformationDialogModule } from '../shared/dialog/information-dialog/information-dialog.module';
import { SharedModule } from '../shared/shared.module';
import { AccountLockedComponent } from './account-locked/account-locked.component';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { AuthenticationComponent } from './authentication/authentication.component';
import { LoginErrorComponent } from './login-error/login-error.component';
import { PrivacyStatementComponent } from './privacy-statement/privacy-statement.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpErrorComponent } from './sign-up-error/sign-up-error.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignupSuccessComponent } from './signup-success/signup-success.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { RecaptchaEnterpriseModule } from '../shared/recaptcha-enterprise/recaptcha-enterprise.module';
@NgModule({
  declarations: [
    AuthenticationComponent,
    SignUpComponent,
    SignInComponent,
    SignUpCompletedComponent,
    SignUpErrorComponent,
    TermsConditionsComponent,
    PrivacyStatementComponent,
    SignupSuccessComponent,
    AccountLockedComponent,
    LoginErrorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    PhoneMaskDirective,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    SharedModule,
    AuthenticationRoutingModule,
    MatRadioModule,
    RecaptchaEnterpriseModule,
    InformationDialogModule,
  ],
  providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthenticationModule { }

export { AuthenticationComponent } from './authentication/authentication.component';
export { ROUTE_SIGNIN, ROUTE_SIGNUP } from './shared/routes';

